import { SxProps, TextField as MuiTextField, Theme } from '@mui/material'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { cepMask } from 'utils/cep.util'

function unmaskCnj(value: string): string {
  // Remove a máscara do CNJ
  return value.replace(/\D/g, '')
}

interface TextFieldProps<TFieldValues extends FieldValues> {
  label?: string
  name: Path<TFieldValues>
  placeholder?: string
  minRows?: number
  multiline?: boolean
  sx?: SxProps<Theme>
  control: Control<TFieldValues>
  disabled?: boolean
  required?: boolean
  readonly?: boolean
}

function FormInputCep<TFieldValues extends FieldValues>({
  label,
  name,
  placeholder,
  multiline,
  minRows,
  sx,
  control,
  disabled,
  readonly,
  required = false,
}: TextFieldProps<TFieldValues>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <MuiTextField
          type={'text'}
          fullWidth
          id={`${name}Id`}
          label={label}
          name={name}
          value={cepMask(value)}
          size='small'
          placeholder={placeholder}
          onChange={(e) => onChange(unmaskCnj(e.target.value))}
          InputProps={{
            inputProps: {
              maxLength: 9,
            },
            readOnly: readonly,
          }}
          minRows={minRows}
          multiline={multiline}
          sx={sx}
          error={!!error}
          helperText={error && error.message && error.message}
          disabled={disabled}
          required={required}
        />
      )}
    />
  )
}

export default FormInputCep
